module.exports = __webpack_public_path__ + "img/Upright_hardcover_boek_datagastronoom.62c6d04d.png";